import { render, staticRenderFns } from "./ProductFilterContent.vue?vue&type=template&id=520b769d&"
import script from "./ProductFilterContent.vue?vue&type=script&lang=js&"
export * from "./ProductFilterContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports